module.exports = __webpack_public_path__ + "static/media/upload-icon.d1e96b70.svg";